(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-category-card/assets/javascripts/casino-category-card.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-category-card/assets/javascripts/casino-category-card.js');

'use strict';

const Icon = svs.ui.ReactIcon;
const urlMapping = svs.core.urlMapping;
const {
  Link
} = ReactRouterDOM;
const {
  dispatchGameToLastSearched
} = svs.components.casino_react.casinoStore.utils.lastSearched;
const {
  CardType
} = svs.components.casino_react.common.constants;
const cmsCategoryList = svs.casino_react.shared.data.cmsCategoryList;
const cmsLiveCategoryList = svs.casino_react.shared.data.cmsLiveCategoryList;
const CasinoCardWrapper = svs.components.casino_react.CasinoCardWrapper;
const CasinoCardFallback = svs.components.casino_react.casinoCardFallback;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const CasinoCategoryCard = _ref => {
  var _categoryList$find$mo, _categoryList$find;
  let {
    categoryName
  } = _ref;
  const categoryList = [...cmsLiveCategoryList, ...cmsCategoryList];
  const isSmallScreen = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const categoryModel = (_categoryList$find$mo = (_categoryList$find = categoryList.find(category => category.model.systemName === categoryName)) === null || _categoryList$find === void 0 ? void 0 : _categoryList$find.model) !== null && _categoryList$find$mo !== void 0 ? _categoryList$find$mo : {};
  if (!(categoryModel !== null && categoryModel !== void 0 && categoryModel.name)) {
    return React.createElement(CasinoCardFallback, {
      subtitle: "Otill\xE4nglig kategori",
      title: categoryName
    });
  }
  const urlMap = categoryModel.isLive ? urlMapping.get('casinoLiveCategory') : urlMapping.get('casinoCategory');
  const returnUrl = window.location.pathname + window.location.search;
  const categoryPath = "".concat(urlMap, "/").concat(categoryModel.systemName, "?returnUrl=").concat(encodeURIComponent(returnUrl));
  const icon = categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.icon;
  return React.createElement(CasinoCardWrapper, null, React.createElement(Link, {
    className: "casino-category-card",
    onClick: () => dispatchGameToLastSearched("".concat(CardType.CATEGORY, "_").concat(categoryModel.systemName)),
    title: "L\xE4s mer om ".concat(categoryModel.name),
    to: categoryPath
  }, React.createElement(Icon, {
    color: "icon-inverted",
    icon: icon,
    size: isSmallScreen ? 300 : 600
  }), React.createElement("h3", {
    className: "fc-white casino-category-card__title",
    "data-testid": "provider-img-fallback"
  }, categoryModel.name)));
};
setGlobal('svs.components.casino_react.casinoCategoryCard.CasinoCategoryCard', CasinoCategoryCard);

 })(window);